import { render } from "./UserManagementPage.vue?vue&type=template&id=0755a8ff&scoped=true"
import script from "./UserManagementPage.vue?vue&type=script&lang=js"
export * from "./UserManagementPage.vue?vue&type=script&lang=js"

import "./UserManagementPage.vue?vue&type=style&index=0&id=0755a8ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0755a8ff"]])

export default __exports__